import { CONTENT_MANAGER_USERBOOK_ID, OPEN_EDUBOOK_USERBOOK_ID } from './constants/constants'

const ViewerConfig = {
  isAnnotationsEnabled() {
    return window?.viewer?.config?.annotationsEnabled ?? true
  },
  isAttemptsEncrypted() {
    return window?.viewer?.config?.attemptsEncrypted ?? true
  },
  isBookmarkEnabled() {
    return window?.viewer?.config?.bookmarkEnabled ?? true
  },
  isGoOutEnabled() {
    return window?.viewer?.config?.goOutEnabled ?? true
  },
  isHighlightsEnabled() {
    return window?.viewer?.config?.highlightsEnabled ?? false
  },
  isLocal() {
    return window?.location?.hostname === 'localhost'
  },
  isOpen() {
    return (
      window?.location?.hostname.startsWith('open') ||
      window?.location?.hostname.startsWith('sample')
    )
  },
  isPreview() {
    return window?.location?.hostname.startsWith('preview')
  },
  isPreviewContentManager() {
    return window?.viewer?.config?.isPreviewContentManager
  },
  isPreviewOrOpen(userBookId) {
    return (
      this.isPreview() ||
      this.isOpen() ||
      userBookId === CONTENT_MANAGER_USERBOOK_ID ||
      userBookId === OPEN_EDUBOOK_USERBOOK_ID
    )
  },
  isSampleGetBookEnabled() {
    return window?.viewer?.config?.sampleGetBookEnabled ?? false
  },
  isSaveAttemptsEnabled() {
    return window?.viewer?.config?.saveAttemptsEnabled ?? true
  },
  shouldShowSlideMode(knowledgeArea) {
    if (window.viewer.noSlideModeKnowledgeAreas) {
      return window.viewer.noSlideModeKnowledgeAreas.indexOf(knowledgeArea) === -1
    }

    return true
  },
}

export default ViewerConfig
